import { createFileRoute, notFound } from '@tanstack/react-router'

// Bare /public has no page of its own; without this index route the pathful
// layout route would match it and render an empty Outlet.
export const Route = createFileRoute('/public/')({
  beforeLoad: () => {
    throw notFound()
  },
})
